import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { BookkeepingManagerContainer } from '@/features/admin/bookkeeping/BookkeepingManager/BookkeepingManagerContainer'
import { type AdminViewModel } from '@/features/admin/AdminViewModel'

export default observer(function AdminBookkeepingManagerContainer() {
  const vm = useOutletContext<AdminViewModel>()
  return vm.canManageBookkeeping ? (
    <BookkeepingManagerContainer vm={vm.bookkeepingManagerVm} />
  ) : null
})
